import { createGlobalStyle, css } from 'styled-components';
import { fonts } from '../../../../shared/ui/styles/GlobalStyle';
import BeelineRegularEot from '../../../../main-service/ui/shared/assets/fonts/beeline/Beeline_Sans-Regular.eot';
import BeelineRegularWoff from '../../../../main-service/ui/shared/assets/fonts/beeline/Beeline_Sans-Regular.woff';
import BeelineRegularWoff2 from '../../../../main-service/ui/shared/assets/fonts/beeline/Beeline_Sans-Regular.woff2';
import BeelineRegularTtf from '../../../../main-service/ui/shared/assets/fonts/beeline/BeelineSans-Regular.ttf';

const beelineFonts = css`
  @font-face {
    font-family: 'BeelineSansRegular';
    font-style: normal;
    font-weight: 400;
    src: url(${BeelineRegularEot});
    src: url(${BeelineRegularWoff2}) format('woff2'), url(${BeelineRegularWoff}) format('woff'),
      url(${BeelineRegularEot}) format('embedded-opentype'),
      url(${BeelineRegularTtf}) format('truetype');
  }
`;

const crmLegacyReset = css`
  html {
    margin: 0;
    padding: 0;
    border: 0;
    font-size: 100%;
  }

  body,
  div,
  span,
  object,
  iframe,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p,
  blockquote,
  pre,
  a,
  abbr,
  acronym,
  address,
  code,
  del,
  dfn,
  em,
  img,
  q,
  dl,
  dt,
  dd,
  ol,
  ul,
  li,
  fieldset,
  form,
  label,
  legend,
  table,
  caption,
  tbody,
  tfoot,
  thead,
  tr,
  th,
  td,
  article,
  aside,
  dialog,
  figure,
  footer,
  header,
  hgroup,
  nav,
  section {
    margin: 0;
    padding: 0;
    border: 0;
    font-size: 100%;
    font: inherit;
    vertical-align: baseline;
  }

  article,
  aside,
  details,
  figcaption,
  figure,
  dialog,
  footer,
  header,
  hgroup,
  menu,
  nav,
  section {
    display: block;
  }

  body {
    line-height: 1.5;
    background: white;
    font-family: 'Helvetica Neue', Arial, Helvetica, sans-serif;
  }

  table {
    border-collapse: separate;
    border-spacing: 0;
  }

  caption,
  th,
  td {
    text-align: left;
    font-weight: inherit;
    float: none !important;
  }

  table,
  th,
  td {
    vertical-align: middle;
  }

  blockquote:before,
  blockquote:after,
  q:before,
  q:after {
    content: '';
  }

  blockquote,
  q {
    quotes: '' '';
  }

  a img {
    border: none;
  }

  :focus {
    outline: 0;
  }
`;

const AppLoaderGlobalStyle = createGlobalStyle`
  ${fonts}
  ${beelineFonts}
  ${crmLegacyReset}

  .my-node-enter {
    opacity: 0;
  }
  .my-node-enter-active {
    opacity: 1;
    transition: opacity 1200ms;
  }
  .my-node-exit {
    opacity: 1;
  }
  .my-node-exit-active {
    opacity: 0;
    transition: opacity 1200ms;
  }

  .ant-notification .ant-notification-notice-wrapper .notification-popup .ant-notification-notice-close {
    top: 12px !important;
    right: 16px;
  }

  .ant-notification .ant-notification-notice-wrapper .ant-notification-notice {
    padding-bottom: 10px;
  }

  #root {
    font-size: 16px;
    font-family: 'SkorozvonRoboto';

    ul {
      margin: 0;
    }

    h1,
    h2,
    h3,
    h4,
    h5 {
      font-weight: 500 !important;
      margin: 0;
    }

    iframe {
      border: none;
    }

    div,
    section,
    footer,
    header {
      box-sizing: border-box;
    }
  }
`;

export { AppLoaderGlobalStyle };
